import {Center, Flex, Image, Text} from '@chakra-ui/react'
import LightIcon from '@assets/svgs/exam/light-bulb.svg'
import MicIcon from '@assets/svgs/exam/mic.svg'
import AzIcon from '@assets/svgs/exam/az.svg'
import BookIcon from '@assets/svgs/exam/book.svg'
import {
  getBadgeByScore,
  getColorByScore,
  getColorBySpeedRate,
  getSpeedRateBadge,
} from './utilsExamResult'
import {useSelector} from 'react-redux'

const Overview = () => {
  const {dataExamResult, tabValue} = useSelector(
    (state: any) => state.examResult,
  )

  return (
    <Flex className="overview" gap={'16px'}>
      {tabValue === 1 && (
        <>
          <Flex flex={1} flexDirection={'column'} gap={'8px'}>
            <Text
              fontSize={'16px'}
              fontWeight={700}
              align={'center'}
              color={getColorBySpeedRate(
                dataExamResult?.feedbacks?.speech_rate?.score.toFixed(0),
              )}>
              Tốc độ nói
            </Text>
            <Center position={'relative'}>
              <Image
                w={'140px'}
                src={getSpeedRateBadge(
                  dataExamResult?.feedbacks?.speech_rate?.score.toFixed(0),
                )}
              />
              <Text
                pb={'8px'}
                fontSize={'40px'}
                fontWeight={700}
                color={'white'}
                position={'absolute'}
                top={'50%'}
                left={'50%'}
                transform={'translate(-50%, -50%)'}>
                {dataExamResult?.feedbacks?.speech_rate?.score.toFixed(0)}
              </Text>
            </Center>
            <Text
              className="line-clamp-3"
              fontSize={'20px'}
              fontWeight={700}
              align={'center'}
              color={getColorBySpeedRate(
                dataExamResult?.feedbacks?.speech_rate?.score.toFixed(0),
              )}>
              {dataExamResult?.feedbacks?.speech_rate?.feedback_title}
            </Text>
            <Text
              className="line-clamp-3"
              fontSize={'16px'}
              fontWeight={500}
              align={'center'}
              color={'#595959'}>
              {dataExamResult?.feedbacks?.speech_rate?.feedback_detail}
            </Text>
          </Flex>
          <Flex flex={1} flexDirection={'column'} gap={'8px'}>
            <Text
              fontSize={'16px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(dataExamResult?.statistics?.fluency)}>
              Độ trôi chảy
            </Text>
            <Center position={'relative'}>
              <Image
                w={'140px'}
                src={getBadgeByScore(dataExamResult?.statistics?.fluency)}
              />
              <Image
                w={''}
                src={LightIcon}
                position={'absolute'}
                top={'50%'}
                left={'50%'}
                transform={'translate(-50%, -50%)'}
              />
            </Center>
            <Text
              className="line-clamp-3"
              fontSize={'20px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(dataExamResult?.statistics?.fluency)}>
              {dataExamResult?.feedbacks?.fluency?.feedback_title}
            </Text>
            <Text
              className="line-clamp-3"
              fontSize={'16px'}
              fontWeight={500}
              align={'center'}
              color={'#595959'}>
              {dataExamResult?.feedbacks?.fluency?.feedback_detail}
            </Text>
          </Flex>
          <Flex flex={1} flexDirection={'column'} gap={'8px'}>
            <Text
              fontSize={'16px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(
                dataExamResult?.statistics?.pronunciation,
              )}>
              Phát âm
            </Text>
            <Center position={'relative'}>
              <Image
                w={'140px'}
                src={getBadgeByScore(dataExamResult?.statistics?.pronunciation)}
              />
              <Image
                w={''}
                src={MicIcon}
                position={'absolute'}
                top={'50%'}
                left={'50%'}
                transform={'translate(-50%, -50%)'}
              />
            </Center>
            <Text
              className="line-clamp-3"
              fontSize={'20px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(
                dataExamResult?.statistics?.pronunciation,
              )}>
              {dataExamResult?.feedbacks?.pronunciation?.feedback_title}
            </Text>
            <Text
              className="line-clamp-3"
              fontSize={'16px'}
              fontWeight={500}
              align={'center'}
              color={'#595959'}>
              {dataExamResult?.feedbacks?.pronunciation?.feedback_detail}
            </Text>
          </Flex>
        </>
      )}
      {tabValue === 2 && (
        <>
          <Flex flex={1} flexDirection={'column'} gap={'8px'}>
            <Text
              fontSize={'16px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(dataExamResult?.statistics?.grammar)}>
              Ngữ pháp
            </Text>
            <Center position={'relative'}>
              <Image
                w={'140px'}
                src={getBadgeByScore(dataExamResult?.statistics?.grammar)}
              />
              <Image
                w={''}
                src={BookIcon}
                position={'absolute'}
                top={'50%'}
                left={'50%'}
                transform={'translate(-50%, -50%)'}
              />
            </Center>
            <Text
              className="line-clamp-3"
              fontSize={'20px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(dataExamResult?.statistics?.grammar)}>
              {dataExamResult?.feedbacks?.grammar?.feedback_title}
            </Text>
            <Text
              className="line-clamp-3"
              fontSize={'16px'}
              fontWeight={500}
              align={'center'}
              color={'#595959'}>
              {dataExamResult?.feedbacks?.grammar?.feedback_detail}
            </Text>
          </Flex>
          <Flex flex={1} flexDirection={'column'} gap={'8px'}>
            <Text
              fontSize={'16px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(dataExamResult?.statistics?.vocabulary)}>
              Từ vựng
            </Text>
            <Center position={'relative'}>
              <Image
                w={'140px'}
                src={getBadgeByScore(dataExamResult?.statistics?.vocabulary)}
              />
              <Image
                w={''}
                src={AzIcon}
                position={'absolute'}
                top={'50%'}
                left={'50%'}
                transform={'translate(-50%, -50%)'}
              />
            </Center>
            <Text
              className="line-clamp-3"
              fontSize={'20px'}
              fontWeight={700}
              align={'center'}
              color={getColorByScore(dataExamResult?.statistics?.vocabulary)}>
              {dataExamResult?.feedbacks?.vocabulary?.feedback_title}
            </Text>
            <Text
              className="line-clamp-3"
              fontSize={'16px'}
              fontWeight={500}
              align={'center'}
              color={'#595959'}>
              {dataExamResult?.feedbacks?.vocabulary?.feedback_detail}
            </Text>
          </Flex>
        </>
      )}
    </Flex>
  )
}

export default Overview
